import { Button } from 'primereact/button';
import { CodeHighlight } from './components2/CodeHighlight';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AuthenticationService from './services/AuthenticationService';
import classNames from 'classnames';
import CurrentUserService from './services/CurrentUserService'
import './login.css'
import Doc from './Doc';


function Login(props) {
    const [data, setData] = useState({ rememberMe: false });
    const [loading, setLoading] = useState(false);
    let history = useHistory();
    let params = useParams();

    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        document.addEventListener('keydown', keyDownHandler);
        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    })

    const keyDownHandler = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            authenticate();
        }
    }

    const bind = (e) => {
        if (e.target.value !== undefined) {
            let value = e.target.value;
            setData({ ...data, [e.target.id]: value });
        }
        else if (e.checked !== undefined) {
            setData({ ...data, [e.target.id]: e.target.checked });
        } else {
            alert("Binding fails.")
        }
        //console.log(e)
    }

    function authenticate() {
        setSubmitted(true);

        if (submitted === false) {
            //showError()
        } else {
            setLoading(true);
            let credentials = data;
            AuthenticationService.authenticate(credentials, (response, status) => {
                setLoading(false);
                if (!status) return;
                //showSuccess();
                localStorage.setItem('token', response.token)
                localStorage.setItem("user", JSON.stringify(response, null, 2))
                CurrentUserService.build();
                if (params.state) history.goBack();
                else {
                    history.replace("/dashboard");
                }
            });
        }

    }

    //const [checked, setChecked] = useState(false);

    return (
        <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className='card w-full lg:w-9'>
                <div className='grid'>
                    <div className="col-12 lg:col-5 py-5 flex align-items-center justify-content-center">
                        <div className='p-fluid '>
                            <div className="text-center mb-5">
                                <img src="benin.jpg" alt="hyper" width="150px"  height="auto" className="mb-3" />
                            </div>
                            <label htmlFor="username" className="block text-900 font-medium mb-2">Nom d'utilisateur</label>
                            <InputText id="username" type="text" value={data?.username} onChange={bind}
                                required className={classNames("w-full mb-3", { 'p-invalid': submitted && !data?.username })}
                                placeholder="Nom d'utilisateur"
                            />
                            <label htmlFor="password" className="block text-900 font-medium mb-2">Mot de passe</label>
                            <Password inputId="password" toggleMask value={data?.password} onChange={bind}
                                required className={classNames('w-full mb-3', { 'p-invalid': submitted && !data?.password })}
                                placeholder='mot de passe'
                            />
                            <div className="flex align-items-center justify-content-between mb-6">
                                <div className="flex align-items-center">
                                    <Checkbox id="rememberMe" className="mr-2" onChange={bind} checked={data.rememberMe} />
                                    <label htmlFor="rememberMe">Se souvenir de moi</label>
                                </div>
                            </div>
                            <Button autoFocus label="Se connecter" icon="pi pi-user" iconPos="right" className="w-full" loading={loading} onClick={authenticate} />
                        </div>
                    </div>
                    <div className="col-1 hidden lg:inline-block">
                        <Divider layout="vertical">
                            <i className="pi pi-plus"></i>
                        </Divider>
                    </div>
                    <div className="col-12 lg:col-6 align-items-center justify-content-center" style={{maxHeight: '80vh', overflowY: 'auto'}}>
                        <Doc />
                    </div>
                </div>
                <div className="layout-footer -mb-4" style={{borderTop: "0px"}}>
                    <span className="col py-1 m-0" style={{ backgroundColor: '#0C623B' }}></span>
                    <span className="col py-1 m-0" style={{ backgroundColor: '#FEC929' }}></span>
                    <span className="col py-1 m-0" style={{ backgroundColor: '#ED242C' }}></span>
                </div>
            </div>
        </div>
    );
}

export default Login;
